import { render, staticRenderFns } from "./advert-manage.vue?vue&type=template&id=5c59628c"
import script from "./advert-manage.vue?vue&type=script&lang=ts"
export * from "./advert-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports